export { default as FlightDetailsBottomSheet } from './FlightDetailsBottomSheet.vue';
